import reload from '@src/utils/reload';
import onPageShowByCache from '@src/utils/on-page-show-by-cache';

/**
 * 当页面命中缓存时候强行刷新页面
 */
export default function reloadWhenPageShowByCache() {
  const dispose = onPageShowByCache(() => {
    dispose();
    reload();
  });
}
